export const userMixin = {
    computed: {
        User() {
            return this.$store.state.User
        },
        UserCan() {
            return this.$store.state.UserCan
        }
    },

    methods: {
        $can(permission) {
            return this.UserCan['all_permissions'] || this.UserCan[permission] != null
        },
    }
}